import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import NoResults from '../../components/NoResults';
import PageLoader from '../../../shared/components/PageLoader';
import PageWrapper from '../../../shared/components/PageWrapper';
import SellersHeader from '../../components/SellersHeader';
import VendorCard from '../../components/VendorCard';
import { useStorefrontState } from '../../../hooks/useReduxState';
import { getAllSellersData } from '../../../store/actions/storefrontActions';
import { LoadMoreWrapper } from './Sellers.styles';
import { Grid, spacing5 } from '@leaftrade/leaftrade-component-library';
import {
  GRID_HORIZONTAL_OFFSET,
  GRID_ITEM_CSS_CLASS,
  GRID_ITEM_WIDTH,
  GRID_LIST_VIEW_SX,
  MAX_GRID_WIDTH,
} from '../../constants';

const Sellers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { ref, inView } = useInView();
  const { sellersPageData } = useStorefrontState();
  const { hasAdditionalSellers, isLoadingAllSellersData, vendors, isGridView } =
    sellersPageData;

  const [pageNumber, setPageNumber] = useState(0);

  const queryParamsParsed = queryString.parse(location.search);

  const handleClearQueryParams = () => {
    navigate({
      pathname: location.pathname,
      search: '',
    });
    dispatch(getAllSellersData({}));
  };

  useEffect(() => {
    dispatch(
      getAllSellersData({
        queryString: queryString.stringify(queryParamsParsed),
      })
    );
  }, []);

  useEffect(() => {
    if (inView && hasAdditionalSellers) {
      queryParamsParsed.page_num = pageNumber + 1;
      queryParamsParsed.last_vendor = vendors[vendors.length - 1].id;

      dispatch(
        getAllSellersData({
          queryString: queryString.stringify(queryParamsParsed),
          isLoadingMore: true,
        })
      );

      setPageNumber(pageNumber + 1);
    }
  }, [inView]);

  return (
    <>
      <SellersHeader />
      {isLoadingAllSellersData ? (
        <PageLoader />
      ) : (
        <>
          <PageWrapper sidePadding='small'>
            <Grid
              cssItemSelector={`.${GRID_ITEM_CSS_CLASS}`}
              maxItemWidth={
                vendors?.length && isGridView ? GRID_ITEM_WIDTH : MAX_GRID_WIDTH
              }
              maxColumns={vendors?.length && isGridView ? 4 : 1}
              gap={spacing5}
              horizontalOffset={GRID_HORIZONTAL_OFFSET}
              sx={isGridView ? {} : GRID_LIST_VIEW_SX}
            >
              {vendors.length ? (
                vendors.map((vendor) => (
                  <VendorCard key={vendor.id} vendor={vendor} />
                ))
              ) : (
                <NoResults
                  onClear={handleClearQueryParams}
                  resultsType='sellers'
                />
              )}
            </Grid>
          </PageWrapper>
          {hasAdditionalSellers && (
            <LoadMoreWrapper ref={ref}>
              <PageLoader message='Fetching more results' />
            </LoadMoreWrapper>
          )}
        </>
      )}
    </>
  );
};

export default Sellers;
